<rs-general-dialog
  [dialogTitle]="dialogTitle"
  [description]="description"
  [visible]="isVisible()"
  (visibleChange)="isVisible.set($event)"
  [contentClass]="['rs-dialog-table', 'rs-dialog-inputs', 'esim-lookup-dialog-content']"
  [maximizable]="true"
  [dialogStyle]="{ width: '75vw', height: '95vh', maxWidth: '95vw', maxHeight: '95vh' }"
  (exitAction)="clearLookup()"
>
  <rs-icon headerIcon [icon]="RIPSIM_ICONS.view"></rs-icon>

  <div class="my-3">
    <div class="esim-lookup-search-row">
      <label class="rs-bold nobr" for="esim-lookup-search" i18n>ICCID</label>
      <p-inputgroup class="lookup-inputgroup">
        <input
          type="search"
          id="esim-lookup-search"
          pInputText
          [(ngModel)]="_eSimLookup().iccid"
          maxlength="20"
          (keydown.enter)="loadEsimProfile()"
        />
        <p-inputgroup-addon>
          <p-button icon="pi pi-search" (onClick)="loadEsimProfile()"></p-button>
        </p-inputgroup-addon>
      </p-inputgroup>
      <p-inputgroup *ngIf="_eSimLookup().eSimProfileJson" class="lookup-inputgroup">
        <input
          type="search"
          id="esim-lookup-search"
          pInputText
          i18n-placeholder
          placeholder="Search Profile Contents"
          [(ngModel)]="searchValue"
          (keydown.enter)="searchValueSignal.set(this.searchValue)"
        />
        <p-inputgroup-addon>
          <p-button icon="pi pi-search" (onClick)="searchValueSignal.set(this.searchValue)" />
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>
    <ng-container *ngIf="_eSimLookup().eSimProfileJson && _eSimLookup() as eSimLookup">
      <div class="mt-2" style="display: flex; flex-wrap: wrap; align-items: center; gap: 1.5rem">
        <div class="mr-5">
          <div class="input-help-label tight" i18n>Timestamp</div>
          <span>{{ eSimLookup.updatedOnUtc | date: "medium" }}</span>
        </div>
        <div class="mr-5">
          <div class="input-help-label tight" i18n>Job Name</div>
          <span>
            {{ eSimLookup.jobName }}
            <ng-container *ngIf="eSimLookup.isOrderDeleted" i18n>(Deleted)</ng-container>
          </span>
        </div>
        <div class="mr-5">
          <div class="input-help-label tight" i18n>Job Template</div>
          <span>
            {{ eSimLookup.jobTemplateName }}
            <ng-container *ngIf="eSimLookup.isJobTemplateDeleted" i18n>(Deleted)</ng-container>
          </span>
        </div>
        <div>
          <div class="input-help-label tight" i18n>Order Type</div>
          <span>
            @if (isIntelligent()) {
              <ng-container i18n>Intelligent</ng-container>
            } @else {
              <ng-container i18n>Standard</ng-container>
            }
          </span>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="profile-lookup-panel">
    <p-tabs class="lookup-mode-tabs" [value]="activeTab()" (valueChange)="onActiveTabChange($event)">
      <p-tablist>
        @if (isIntelligent()) {
          @for (template of previewTemplates(); track template.id; let i = $index) {
            <p-tab [value]="i" [disabled]="isRenderingPreview()">{{ labelOf(template) }}</p-tab>
          }
        } @else {
          <p-tab [value]="0" i18n>Profile</p-tab>
          <p-tab [value]="1" i18n>Template</p-tab>
        }
      </p-tablist>
    </p-tabs>
    <div *ngIf="!displaySections()?.length; else displayContent" class="no-data-text">
      @if (isRenderingPreview()) {
        <span i18n>Rendering this template…</span>
      } @else if (isIntelligent() && !previewTemplates().length) {
        <span i18n>This eSIM's destination has no template registered on its SM-DP+, so there is nothing to render.</span>
      } @else {
        <span i18n>No data is available for this iccid.</span>
      }
    </div>
    <ng-template #displayContent>
      <p-tabs
        class="esim-lookup-section-tabs"
        [scrollable]="true"
        [value]="activeSectionTab()"
        (valueChange)="onActiveSectionTabChange($event)"
      >
        <p-tablist>
          <p-tab *ngFor="let section of displaySections(); let i = index" [value]="i">
            {{ section.label }}
          </p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel *ngFor="let section of displaySections(); let i = index" [value]="i">
            <rs-json-viewer [json]="section.json" [expanded]="true" />
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </ng-template>
  </div>
  <ng-template pTemplate="footer">
    <ng-container *ngIf="_eSimLookup().eSimProfileJson && isProfileTab()">
      <p-button [disabled]="isLoading()" [loading]="isLoading()" i18n-label label="Copy ASN.1" [outlined]="true" (onClick)="copyAsn1()" />
    </ng-container>

    <ng-container *ngIf="_eSimLookup().profileHex && isProfileTab()">
      <p-button i18n-label label="Copy DER" [outlined]="true" (onClick)="copyDer()" />
    </ng-container>

    <ng-container *ngIf="isProfileTab(); else templateCopy">
      <ng-container *ngIf="_eSimLookup().eSimProfileJson">
        <p-button i18n-label label="Copy JSON" [outlined]="true" (onClick)="copyEsimProfileJson()" />
      </ng-container>
    </ng-container>
    <ng-template #templateCopy>
      <ng-container *ngIf="_eSimLookup().eSimTemplateJson">
        <p-button i18n-label label="Copy JSON" [outlined]="true" (onClick)="copyEsimTemplateJson()" />
      </ng-container>
    </ng-template>
    <p-button i18n-label label="Close" (onClick)="clearLookup()" />
  </ng-template>
</rs-general-dialog>
